import index from './index'

export default [
  { path: '/timeline', component: index },
]